import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregation = {
    range: '_rangeAggregation',
    nested: '_nestedAggregation',
};
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
    groupedByValue: '_groupByValueResults',
    nested: '_nestedResults',
};
var _aggregationResultsScalarResult = { value: 'DOUBLE' };
var _cancelInvocationRequest = {};
var _cancelInvocationResponse = { invocation: '_invocation' };
var _countInvocationsRequest = {};
var _countInvocationsResponse = {};
var _createInvocationRequest = { invocation: '_invocation' };
var _createInvocationResponse = { invocation: '_invocation' };
var _cursorSearch = { aggregations: '_aggregation' };
var _getInvocationRequest = {};
var _getInvocationResponse = { invocation: '_invocation' };
var _getRuntimeInvocationStateRequest = {};
var _getRuntimeInvocationStateResponse = {};
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _invocation = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    lastActivityDate: 'google.protobuf.Timestamp',
};
var _nestedAggregation = { nestedAggregations: '_nestedAggregationItem' };
var _nestedAggregationItem = { range: '_rangeAggregation' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_aggregationResultsScalarResult',
};
var _nestedResults = { results: '_results' };
var _nestedResultValue = { range: '_rangeResult', scalar: '_scalarResult' };
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryInvocationsRequest = {};
var _queryInvocationsResponse = { invocations: '_invocation' };
var _rangeAggregation = { buckets: '_rangeBucket' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeBucket = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _results = { results: 'Map#_nestedResultValue' };
var _scalarResult = { value: 'DOUBLE' };
var _searchInvocationsRequest = { search: '_cursorSearch' };
var _searchInvocationsResponse = {
    invocations: '_invocation',
    aggregationData: '_aggregationData',
};
function resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/agent-maker-invocations',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/agent-maker-invocations',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/agent-maker-invocations',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_api/agent-maker-invocations',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a Invocation. */
export function createInvocation(payload) {
    var _a = serializer(_createInvocationRequest, { _invocation: _invocation }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createInvocationResponse, {
        _invocation: _invocation,
    }).fromJSON;
    function __createInvocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.invocations.v1.invocation',
            method: 'POST',
            methodFqn: 'wix.agentmaker.invocations.v1.AgentMakerInvocations.CreateInvocation',
            url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                protoPath: '/v1/invocations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createInvocation.fromReq = fromReq;
    __createInvocation.__isAmbassador = true;
    return __createInvocation;
}
/** Retrieves a single Invocation by ID. */
export function getInvocation(payload) {
    var _a = serializer(_getInvocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInvocationResponse, {
        _invocation: _invocation,
    }).fromJSON;
    function __getInvocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.invocations.v1.invocation',
            method: 'GET',
            methodFqn: 'wix.agentmaker.invocations.v1.AgentMakerInvocations.GetInvocation',
            url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                protoPath: '/v1/invocations/{invocationId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInvocation.fromReq = fromReq;
    __getInvocation.__isAmbassador = true;
    return __getInvocation;
}
/** Retrieves a list of Invocations, given the provided [paging, filtering, and sorting] */
export function queryInvocations(payload) {
    var _a = serializer(_queryInvocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryInvocationsResponse, {
        _invocation: _invocation,
    }).fromJSON;
    function __queryInvocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.invocations.v1.invocation',
            method: 'GET',
            methodFqn: 'wix.agentmaker.invocations.v1.AgentMakerInvocations.QueryInvocations',
            url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                protoPath: '/v1/invocations/query',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                        protoPath: '/v1/invocations/query',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __queryInvocations.fromReq = fromReq;
    __queryInvocations.__isAmbassador = true;
    return __queryInvocations;
}
/** Retrieves the runtime state for a specific invocation. */
export function getRuntimeInvocationState(payload) {
    var _a = serializer(_getRuntimeInvocationStateRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRuntimeInvocationStateResponse, {}).fromJSON;
    function __getRuntimeInvocationState(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.invocations.v1.invocation',
            method: 'GET',
            methodFqn: 'wix.agentmaker.invocations.v1.AgentMakerInvocations.GetRuntimeInvocationState',
            url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                protoPath: '/v1/invocations/{invocationId}/runtime-state',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRuntimeInvocationState.fromReq = fromReq;
    __getRuntimeInvocationState.__isAmbassador = true;
    return __getRuntimeInvocationState;
}
/** Cancels a running invocation. */
export function cancelInvocation(payload) {
    var _a = serializer(_cancelInvocationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cancelInvocationResponse, {
        _invocation: _invocation,
    }).fromJSON;
    function __cancelInvocation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.invocations.v1.invocation',
            method: 'POST',
            methodFqn: 'wix.agentmaker.invocations.v1.AgentMakerInvocations.CancelInvocation',
            url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                protoPath: '/v1/invocations/{invocationId}/cancel',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cancelInvocation.fromReq = fromReq;
    __cancelInvocation.__isAmbassador = true;
    return __cancelInvocation;
}
/** Searches invocations using Wix Search capabilities. */
export function searchInvocations(payload) {
    var _a = serializer(_searchInvocationsRequest, {
        _aggregation: _aggregation,
        _cursorSearch: _cursorSearch,
        _nestedAggregation: _nestedAggregation,
        _nestedAggregationItem: _nestedAggregationItem,
        _rangeAggregation: _rangeAggregation,
        _rangeBucket: _rangeBucket,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchInvocationsResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _aggregationResultsScalarResult: _aggregationResultsScalarResult,
        _groupByValueResults: _groupByValueResults,
        _invocation: _invocation,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedResultValue: _nestedResultValue,
        _nestedResults: _nestedResults,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResult: _rangeResult,
        _rangeResults: _rangeResults,
        _results: _results,
        _scalarResult: _scalarResult,
    }).fromJSON;
    function __searchInvocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.invocations.v1.invocation',
            method: 'GET',
            methodFqn: 'wix.agentmaker.invocations.v1.AgentMakerInvocations.SearchInvocations',
            url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                protoPath: '/v1/invocations/search',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'POST',
                    url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                        protoPath: '/v1/invocations/search',
                        data: serializedData,
                        host: host,
                    }),
                    data: serializedData,
                },
            ],
        };
        return metadata;
    }
    __searchInvocations.fromReq = fromReq;
    __searchInvocations.__isAmbassador = true;
    return __searchInvocations;
}
/** Counts invocations matching search criteria. */
export function countInvocations(payload) {
    var _a = serializer(_countInvocationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countInvocationsResponse, {}).fromJSON;
    function __countInvocations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.agentmaker.invocations.v1.invocation',
            method: 'POST',
            methodFqn: 'wix.agentmaker.invocations.v1.AgentMakerInvocations.CountInvocations',
            url: resolveWixAgentmakerInvocationsV1AgentMakerInvocationsUrl({
                protoPath: '/v1/invocations/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countInvocations.fromReq = fromReq;
    __countInvocations.__isAmbassador = true;
    return __countInvocations;
}
//# sourceMappingURL=http.impl.js.map